package fyi.moko.hotpl.ui.friends

/**
 * A friend as the badge names them. Display names are captured from the auth provider and
 * for our accounts are plain e-mail addresses; "kakasolg@gmail.com" on a one-line card is
 * mostly the domain, so the part after '@' is dropped (2026-09-20 review). A name that is
 * not an address is left alone.
 */
internal fun friendShortName(displayName: String): String =
    displayName.substringBefore('@').ifBlank { displayName }

/** "kakasolg" / "kakasolg, jwon0331" / "kakasolg, jwon0331 +2" — for the Journal card badge. */
internal fun mutualWishNames(names: List<String>): String {
    val short = names.map(::friendShortName)
    return when {
        short.size <= 2 -> short.joinToString(", ")
        else -> short.take(2).joinToString(", ") + " +${short.size - 2}"
    }
}

/**
 * "kakasolg wants to go too" / "kakasolg and jwon0331 want to go too" — the full sentence
 * for Detail and the Friends card, where there is room for the verb.
 */
internal fun mutualWishCaption(names: List<String>): String {
    val short = names.map(::friendShortName)
    return when (short.size) {
        0 -> "You want to go"
        1 -> "${short[0]} wants to go too"
        2 -> "${short[0]} and ${short[1]} want to go too"
        else -> "${short[0]}, ${short[1]} and ${short.size - 2} more want to go too"
    }
}
